module.exports = __webpack_public_path__ + "static/media/Tulip.0b4497b5.jpg";